import { AxiosInstance } from 'axios';
import { Api, ApiConfig, HttpClient } from '../codegen/Swagger';
interface SwaggerApi {
    httpClient: HttpClient<any> | null;
    api: Api<any> | null;
}

interface SwaggerApiConfiguration<SecurityDataType = unknown> {
    config?: ApiConfig<SecurityDataType>;
    modifyInstance?: (instance: AxiosInstance) => void;
}

// For global acces throughout the application
const singleton: SwaggerApi = {
    httpClient: null,
    api: null,
};

export const configureSwaggerApi = ({ config = {}, modifyInstance }: SwaggerApiConfiguration) => {
    const httpClient = new HttpClient(config);
    if (modifyInstance) modifyInstance(httpClient.instance);

    const api = new Api(httpClient);

    singleton.httpClient = httpClient;
    singleton.api = api;
};

// Helpers for accesing globally the client
// Only these can be used to access the client
export const getSwaggerApi = () => {
    if (!singleton.httpClient) throw new Error('[httpClient] Not Initialized');
    if (!singleton.api) throw new Error('[api] Not Initialized');

    return singleton as SwaggerApi;
};

export const getApi = () => {
    if (!singleton.api) throw new Error('[api] Not Initialized');

    return singleton.api as Api<any>;
};

export const getHttpClient = () => {
    if (!singleton.httpClient) throw new Error('[httpClient] Not Initialized');

    return singleton.httpClient as HttpClient<any>;
};
